import React from 'react';
import { InlineMath } from 'react-katex';

export default (s: string) => (
	<span style={{ color: 'white', opacity: 1 }}>
		<InlineMath math={s} />
	</span>
);
